/**
 * @generated SignedSource<<413397415ed865b78c9e999655f151ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SellerNav_viewer$data = {
  readonly dealerNavBar: {
    readonly buttons: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"NavCreateListing_buttons">;
    } | null> | null;
    readonly links: {
      readonly navItems: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"useActiveNavLink_navItems">;
      } | null> | null;
      readonly " $fragmentSpreads": FragmentRefs<"NavHeader_links" | "NavItems_links">;
    } | null;
    readonly notifications?: {
      readonly " $fragmentSpreads": FragmentRefs<"NavItems_notifications" | "NavLogoHamburger_notifications">;
    } | null;
  } | null;
  readonly seller?: {
    readonly serviceId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"NavCreateListing_seller" | "NavItems_seller" | "NavLogoHamburger_seller" | "NavProfile_seller" | "useSendPresenceHeartbeats_seller">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"NavHeader_viewer" | "NavItems_viewer" | "NavLogoHamburger_viewer" | "NavProfile_viewer" | "useSendPresenceHeartbeats_viewer">;
  readonly " $fragmentType": "SellerNav_viewer";
};
export type SellerNav_viewer$key = {
  readonly " $data"?: SellerNav_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SellerNav_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "customBannerText"
    },
    {
      "kind": "RootArgument",
      "name": "dotComHost"
    },
    {
      "kind": "RootArgument",
      "name": "hasSellerPk"
    },
    {
      "kind": "RootArgument",
      "name": "hyperwalletLink"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "renderNotifications"
    },
    {
      "kind": "RootArgument",
      "name": "sellerPk"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./NavRefetchQuery.graphql')
    }
  },
  "name": "SellerNav_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavHeader_viewer"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useSendPresenceHeartbeats_viewer",
      "selections": [
        {
          "alias": "presenceFeatureFlag",
          "args": [
            {
              "kind": "Literal",
              "name": "feature",
              "value": "presence"
            }
          ],
          "kind": "ScalarField",
          "name": "featureFlag",
          "storageKey": "featureFlag(feature:\"presence\")"
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItems_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavProfile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavLogoHamburger_viewer"
    },
    {
      "condition": "hasSellerPk",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "sellerId",
              "variableName": "sellerPk"
            }
          ],
          "concreteType": "Seller",
          "kind": "LinkedField",
          "name": "seller",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NavCreateListing_seller"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NavItems_seller"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NavProfile_seller"
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "useSendPresenceHeartbeats_seller",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SellerPreferences",
                  "kind": "LinkedField",
                  "name": "sellerPreferences",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "showOnlineStatus",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "args": null,
              "argumentDefinitions": []
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NavLogoHamburger_seller"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "customBannerText",
          "variableName": "customBannerText"
        },
        {
          "kind": "Variable",
          "name": "dotComHost",
          "variableName": "dotComHost"
        },
        {
          "kind": "Variable",
          "name": "hyperwalletLink",
          "variableName": "hyperwalletLink"
        },
        {
          "kind": "Variable",
          "name": "sellerPk",
          "variableName": "sellerPk"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "DealerNavBar",
      "kind": "LinkedField",
      "name": "dealerNavBar",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NavBarButton",
          "kind": "LinkedField",
          "name": "buttons",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NavCreateListing_buttons"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NavBarLinks",
          "kind": "LinkedField",
          "name": "links",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NavHeader_links"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NavItems_links"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "navItems",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "useActiveNavLink_navItems"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "condition": "renderNotifications",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "notifications",
              "args": null,
              "concreteType": "DealerNavBarBadges",
              "kind": "LinkedField",
              "name": "badges",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NavItems_notifications"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NavLogoHamburger_notifications"
                }
              ],
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "34a71025ee4ca46d5e751d729642a91e";

export default node;
